module.exports = __webpack_public_path__ + "static/media/ecosistemico.0f08c157.png";